import { useMutation } from "react-query";

import {
  PREVIOUS_VEHICLE_SEARCH_QUERY_KEY,
  setLocalStorageItem,
} from "../../helpers/localStorage";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const setPreviousVehicleSearchQuery = (options: APQueryOptions = {}) => {
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();
  const invalidateList = [["previous-vehicle-search-query"]];

  return useMutation({
    mutationFn: (query: string) => {
      setLocalStorageItem(PREVIOUS_VEHICLE_SEARCH_QUERY_KEY, query);
      return Promise.resolve(true);
    },
    onError: defaultOnMutateError(options),
    onSettled: () => defaultOnMutateSettled(invalidateList),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
